module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUxMiA2NGMyNDcuNCAwIDQ0OCAyMDAuNiA0NDggNDQ4cy0yMDAuNiA0NDgtNDQ4IDQ0OFM2NCA3NTkuNCA2NCA1MTIgMjY0LjYgNjQgNTEyIDY0eiBtMCA2NDBhMzIgMzIgMCAxIDAgMCA2NCAzMiAzMiAwIDAgMCAwLTY0eiBtMC00NDhhMzIgMzIgMCAwIDAtMzEuOCAyOC4zTDQ4MCAyODh2MzIwYTMyIDMyIDAgMCAwIDYzLjggMy43TDU0NCA2MDhWMjg4YTMyIDMyIDAgMCAwLTMyLTMyeiIgZmlsbD0iIzAiIHAtaWQ9IjQyNTAiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Warning-filled.svg
// module id = y3xX
// module chunks = 73